window.currZoom = {
  zoom: 1,
  videoControlsHe: 100
}
window.widthScreenList = [1680, 1600, 1440, 1400, 1366, 1360, 1280, 1152, 1024]
window.zoomList = [
  {
    zoom: 0.8,
    videoControlsHe: 90
  },
  {
    zoom: 0.8,
    videoControlsHe: 90
  },
  {
    zoom: 0.7,
    videoControlsHe: 80
  },
  {
    zoom: 0.7,
    videoControlsHe: 80
  },
  {
    zoom: 0.6,
    videoControlsHe: 70
  },
  {
    zoom: 0.6,
    videoControlsHe: 70
  },
  {
    zoom: 0.6,
    videoControlsHe: 70
  },
  {
    zoom: 0.5,
    videoControlsHe: 60
  },
  {
    zoom: 0.5,
    videoControlsHe: 60
  }
]

class DevicePixelRatio {
  constructor() {
    //this.flag = false;
  }
  //获取系统类型
  _getSystem() {
    // let flag = false;
    var agent = navigator.userAgent.toLowerCase()
    //		var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    //		if(isMac) {
    //			return false;
    //		}
    //现只针对windows处理，其它系统暂无该情况，如有，继续在此添加
    if (agent.indexOf('windows') >= 0) {
      return true
    }
  }
  //获取页面缩放比例
  //	_getDevicePixelRatio() {
  //		let t = this;
  //	}
  //监听方法兼容写法
  _addHandler(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false)
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, handler)
    } else {
      element['on' + type] = handler
    }
  }
  //校正浏览器缩放比例
  _correct() {

    // let t = this;
    //页面devicePixelRatio（设备像素比例）变化后，计算页面body标签zoom修改其大小，来抵消devicePixelRatio带来的变化。
    let currentWid = (window.currentWid = window.screen.width)
    // if (window.devicePixelRatio > 1) {
    //   document.getElementsByTagName('body')[0].style.zoom = 1 / window.devicePixelRatio
    // } else {
    // if(currentWid <= 1680 && currentWid <= 1600)
    if (currentWid >= 1920) {
      // window.currZoom.zoom = 1 / window.devicePixelRatio
      document.getElementsByTagName('body')[0].style.zoom = window.currZoom.zoom
      console.log(currentWid,"1920")
    } else if (currentWid <= 1680 && currentWid >= 1536) {
      document.getElementsByTagName('body')[0].style.zoom = window.zoomList[0].zoom
      window.currZoom = window.zoomList[0]
      console.log(currentWid, 'A')
    } else if (currentWid <= 1440 && currentWid >= 1400) {
      document.getElementsByTagName('body')[0].style.zoom = window.zoomList[2].zoom
      window.currZoom = window.zoomList[2]
      console.log(currentWid, 'B')
    } else if (currentWid <= 1366 && currentWid >= 1280) {
      // 1366, 1360, 1280
      document.getElementsByTagName('body')[0].style.zoom = window.zoomList[4].zoom
      window.currZoom = window.zoomList[4]
      console.log(currentWid, 'C')
    } else if (currentWid <= 1152 && currentWid >= 1024) {
      //  1152, 1024
      document.getElementsByTagName('body')[0].style.zoom = window.zoomList[7].zoom
      window.currZoom = window.zoomList[7]
      console.log(currentWid, 'D')
    }
    // console.log(currentWid)
    // for (var i = 0; i < window.widthScreenList.length; i++) {
    //   if (currentWid == window.widthScreenList[i]) {
    //     document.getElementsByTagName('body')[0].style.zoom = window.zoomList[i].zoom
    //     window.currZoom = window.zoomList[i]
    //     break
    //   }
    // }
    // }
  }
  //监听页面缩放
  _watch() {
    let t = this
    window.addEventListener('popstate', function() {
      let hash = window.location.hash
      if (hash.includes('play1') || hash.includes('play')) {
        document.getElementsByTagName('body')[0].style = ''
      }
      t._correct()
    })
    t._addHandler(window, 'resize', function() {
      //注意这个方法是解决全局有两个window.resize
      let hash = window.location.hash
      if (hash.includes('play1') || hash.includes('play')) {
        document.getElementsByTagName('body')[0].style = ''
        return
      }
      //重新校正
      t._correct()
    })
  }
  //初始化页面比例
  init() {
    let t = this
    if (t._getSystem()) {
      //判断设备，目前只在windows系统下校正浏览器缩放比例
      //初始化页面校正浏览器缩放比例
      t._correct()
      //开启监听页面缩放
      t._watch()
    }
  }
}
export default DevicePixelRatio
